import { ApiError, createClient } from '@goalbuddy/client';
import { QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const api = createClient({
  baseUrl: '/api',
  onUnauthorized: () => {
    if (!location.pathname.startsWith('/login')) {
      location.assign(`/login?next=${encodeURIComponent(location.pathname + location.search)}`);
    }
  },
});

export const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (n, err) => !(err instanceof ApiError && err.status < 500) && n < 2,
    },
    mutations: {
      onError: (err) => toast.error(err instanceof ApiError ? err.message : String(err)),
      // The data set is small; refetching everything after a write keeps every view consistent.
      onSettled: (): Promise<void> => queryClient.invalidateQueries(),
    },
  },
});

export { ApiError };
